import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { pageResetMiddleWare, zodPage } from 'routes/routeUtils';
import { z } from 'zod';

export const adminInboundMailsRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/inbound-mails',
  validateSearch: z.object({
    page: zodPage,
    tab: z.enum(['received', 'processed', 'archived', 'all']).default('all'),
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() =>
  import('pages/admin/InboundMails/AdminInboundMailsPage/AdminInboundMailsPage').then(
    (d) => d.Route
  )
);
